import { Add } from "@mui/icons-material";
import {
  Box,
  Button,
  Divider,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { createAdminUser, deleteAdmin } from "../../api/users/configApi";
import { setGlobalLoader } from "../../redux/actions/commonAction";
import storage from "../../utils/storage";
import CustomDrawer from "./../../components/drawer/CustomDrawer";
import AdminTable from "./adminTable";
import LogsTable from "./logsTable";
import AdminManagement from "./manageAdmin";
import { useStyles } from "./styles";
import { initilLog, steps } from "./utils";

export const Configure = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [step, setStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedRow, setRow] = useState(null);
  const [logData, setLogs] = useState(initilLog);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const logged = storage.getItem("basicLogin");
    if (!logged) {
      history.push("/login");
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    let newData = [...initilLog];
    newData[0]["tasks"] = tableData;
    setLogs(newData);
  }, [tableData]);

  const handleDelete = (obj) => {
    let newData = [...tableData];
    const filteredUsers = newData.filter((user) => user.email !== obj.email);
    setTableData(filteredUsers);
  };

  const createAdmin = async (data) => {
    const payload = {
      ...data,
      active: true,
      roles: ["admin"],
      accounts: [],
    };
    const result = await createAdminUser(payload);
    return result;
  };

  const deleteDefaultAdmin = async () => {
    let response = await deleteAdmin();
    if (response?.success) {
      let newData = [...logData];
      logData[1]["tasks"][0] = {
        ...logData[1]["tasks"][0],
        success: true,
        message: response?.message,
      };
      setLogs(newData);
      setDone(true);
    }
  };

  const handleNext = () => {
    if (done) {
      storage.clear();
      history.push("/login");
    } else if (step === 0) {
      setStep(1);
    } else {
      dispatch(setGlobalLoader(true));
      const promises = tableData.map((user) => createAdmin(user));
      Promise.all(promises)
        .then((results) => {
          const hasUser = results.some((x) => x.success);
          if (hasUser) {
            deleteDefaultAdmin();
          }
          setTableData(results);
          dispatch(setGlobalLoader(false));
        })
        .catch((error) => {
          dispatch(setGlobalLoader(false));
          console.error("Error updating users:", error);
        });
    }
  };

  const renderFooter = () => (
    <Box className={classes.footerView}>
      <Button
        style={{ display: step === 0 || done ? "none" : "block" }}
        variant="outlined"
        disabled={step === 0}
        onClick={() => setStep(0)}
      >
        Back
      </Button>
      <Button
        disabled={tableData.length === 0}
        variant="contained"
        color="primary"
        onClick={handleNext}
      >
        {done ? "Close" : step === 0 ? "Next" : "Apply"}
      </Button>
    </Box>
  );

  return (
    <Box className={classes.root}>
      <Box className={classes.cardView}>
        <Box className={classes.header}>
          <Stepper
            alternativeLabel
            activeStep={step}
            style={{ width: "50%", padding: "0px" }}
          >
            {steps.map((label) => {
              return (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </Box>
        <Divider />
        <Box className={classes.body}>
          {step === 0 ? (
            <>
              <Box className={classes.btnView}>
                <Typography variant="h5" gutterBottom={true}>
                  Admin Management
                </Typography>
                <Button
                  color="primary"
                  onClick={() => setOpen(true)}
                  startIcon={<Add />}
                  variant="contained"
                >
                  Create Admin
                </Button>
              </Box>
              <AdminTable
                data={tableData}
                onEdit={(value) => {
                  setRow(value);
                  setOpen(true);
                }}
                onDelete={handleDelete}
              />
            </>
          ) : (
            <LogsTable data={logData} />
          )}
          {renderFooter()}
          <CustomDrawer
            title={Boolean(selectedRow) ? "Update Admin" : "Create Admin"}
            open={open}
            onClose={() => {
              setOpen(false);
              setRow(null);
            }}
          >
            <AdminManagement
              edit={Boolean(selectedRow)}
              defaultData={selectedRow}
              data={tableData}
              onClose={() => setOpen(false)}
              onSave={(value) => setTableData(value)}
            />
          </CustomDrawer>
        </Box>
      </Box>
    </Box>
  );
};

export default Configure;
